import { TableAvailability } from "@foodi/core";

export class TableViewModel {
  getValidTableNumbers = (tables: TableAvailability[] | undefined): Array<number> => {
    return tables?.filter(
        tableAvailability => tableAvailability.status < 4,
      ).map(tableAvailability => tableAvailability.tableNumber) ?? [];
  }
}
